import {ScenarioSettingEnum} from '@colonist/game-base-types'

export abstract class BaseScenarioData {
    abstract scenarioSetting: ScenarioSettingEnum
    abstract defaultVPsToWin: number
}
